module.exports = __webpack_public_path__ + "img/vue2-languette_bleu.38edd4a3.png";